import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { Setting } from '../../../core/data/models/setting.model';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

@Injectable()
export class SettingService extends BaseCrudService<Setting> {
  controller = 'Settings';
  fetched = false;

  constructor() {
    super();
    this.getPolicyTypes();
  }

  private _types = new BehaviorSubject<Setting>({});

  $types = this._types.asObservable();

  get types() {
    return this._types.value;
  }

  getPolicyTypes = () => {
    const result = this.get<Setting>({}, `Slob`);
    firstValueFrom(result)
      .then((result) => {
        this.fetched = true;
        this._types.next(result.data);
      })
      .finally(() => {
        this.fetched = true;
      });
    return result;
  };
}
